import styled, { keyframes } from 'styled-components';
const breakpointMobile = '800px';
// Styled components
const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;



export const MainContainer = styled.div` 
  padding-top:25px;
  
`;
export const BoxContainer = styled.div` 
  display:flex;
  flex-direction:row; 
  gap: 3.5rem;
  
  
`;
export const Box = styled.div`  
display:flex;
flex-direction:row;
width:94%;
height: 7em;
flex-shrink: 0;
border-radius: 12px;
background: #FFF;
box-shadow: rgba(0, 0, 0, 0.05) 0px 4px 8px;

`;

export const BoxLabel = styled.div`  
padding-top: 27px;
padding-left: 16px;  
height: 100% 
border-radius: 12px; 
font-size: var(--font-size-lg);
font-weight: bold;
color: var(--color-black);
font-family: var(--font-product-sans);
`;

export const BoxEmptyLabel = styled.div`  
text-align:center;
padding-top: 27px;
padding-left: 16px;  
height: 100% 
border-radius: 12px; 

font-size: 13px;
font-weight: bold;
color: grey;
font-family: var(--font-product-sans);
`;

export const SearchBox = styled.div`  
padding-top: 27px;  
width: 90%;
height: 37px;
flex-shrink: 0; 
`;
export const Search = styled.div`  
 
float:right;
border-radius: var(--br-5xs);
    background-color: rgb(245, 245, 245);
    width: 186px;
    height: 37px;
    margin-right: 10px;
display:flex;
flex-direction:row;
`;

export const SearchImage = styled.img`   
padding:10px;
width: 20px;
height: 20px;
`;

export const SearchInput = styled.input`   
font-size: var(--font-size-xs);
color: var(--color-dimgray);
background-color: rgb(245, 245, 245);
border:none;
outline:none;
`;


export const ScanContainer = styled.div`
  padding-top: 20px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 94%;
  flex-wrap: wrap;

  @media screen and (max-width: ${breakpointMobile}) {
    justify-content: center;
  }
`;

export const ScanBox = styled.div`  
    margin-top:10px;
    box-shadow: rgba(0, 0, 0, 0.05) 0px 4px 8px;
    width: 391px;
    height: 197px;
    display: block;
    animation: ${fadeIn} 1s ease-in-out forwards; /* Apply the fade-in animation */ 

`;
export const Scan = styled.div` 

border-radius: var(--br-xs);
    background-color: var(--color-white);
    width: 391px;
    height: 197px;


`;
export const ScanDeviceRow = styled.div`
  display:flex;
  flex-direction:rows;
`;  
export const ScanDevice = styled.div`
display:flex;
  flex-direction:column;
  padding-top: 20px;
  padding-left: 16px;   
`;
export const Device=styled.div`
min-width:220px;  
  font-weight: bold;  
    color: var(--color-dimgray);
    font-family: var(--font-product-sans);
    font-size: var(--font-size-sm);
    line-height: 20px;   
`;  
export const ScanIcon = styled.div`   
width:20%;
padding-top:20px; 
padding-left:55px;
`;
export const DownloadConatainer = styled.div`   
width:100%;

padding-right:30px;

`;
export const DownloadIcon = styled.img`   
float:right;
width: 24px;
    height: 24px;
    object-fit: cover;
`;
export const CarHealthBad = styled.img`   
float:right;
`;

export const DeviceId = styled.div`   
color: var(--color-black);
font-family: var(--font-product-sans);
font-size: var(--font-size-xs);
line-height: 24px;
font-weight: 600; 
`;

export const Content = styled.div`   
padding-top: 7px;
 padding-left: 16px;
    letter-spacing: -0.18px;
    line-height: 24px;
    display:flex;
  flex-direction:rows;
`;
export const ContentLabel = styled.div`   
text-align: left;
    font-size: var(--font-size-xs);
    color: var(--color-dimgray);
    font-family: var(--font-product-sans);
`;

export const ContentValue = styled.div`   
text-align: left;  
padding-left: 5px;  
font-family: var(--font-product-sans);
letter-spacing: -0.18px;
    line-height: 24px;
    font-weight: bold;
    font-size: var(--font-size-sm);
`;


